import { Component, effect, EventEmitter, Input, Output, output, signal } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TableModule, TableRowExpandEvent } from 'primeng/table';
// import { AssemblyPriceTable } from 'src/app/models/assembly-price-table.model';
import { Assembly } from 'src/app/models/assembly.model';
import { Category } from 'src/app/models/category.model';
import { StandardAssembly } from 'src/app/models/standard-template.model';
import { AssemblyCacheService } from 'src/app/services/app/assembly-cache.service';
import { BannerMessage, BannerMessagesService } from 'src/app/services/app/banner-messages.service';
// import { CatalogService } from 'src/app/services/app/catalog.service';
// import { CategoriesService } from 'src/app/services/app/categories.service';
// import { SelectedAssemblyService } from 'src/app/services/app/selected-assembly.service';
// import { BinderDialogService } from 'src/app/services/binder-dialog.service';
import { AssemblyFilterService } from '../assembly-filter.service';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { AssemblyFilterComponent } from '../assembly-filter/assembly-filter.component';
import { MessageModule } from 'primeng/message';
import { TagModule } from 'primeng/tag';
import { OpsAssemblyEditorComponent } from '../assembly-editor/assembly-editor.component';
import { TooltipModule } from 'primeng/tooltip';
import { CategoriesService } from '@/services/api/categories.service';
import { AssembliesService } from '@/services/api/assemblies.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { OfficesService } from '@/services/api/franchises.service';

@Component({
    selector: 'app-assembly-table',
    imports: [
        CommonModule,
        ToastModule,
        TableModule,
        DialogModule,
        AssemblyFilterComponent,
        MessageModule,
        TagModule,
        OpsAssemblyEditorComponent,
        TooltipModule
    ],
    template: `
    <div class="component-content" style="height: 100%; display: flex; flex-direction: column;">
    <div class="mb-2">
        <app-assembly-filter [officeLocked]="officeLocked" [outputMode]="outputMode"></app-assembly-filter>
    </div>
    <p-toast></p-toast>
    <div class="surface-card shadow-2 border-round p-2" style="flex: 1; display: flex; flex-direction: column; overflow: hidden; max-height: calc(90vh - 180px); width: 100%;">
        <div #assembliesContainer class="assemblies" style="flex: 1; overflow-y: auto;">
            <p-message *ngFor="let message of messages" [severity]="message.type" [closable]="true">
              {{message.summary}}
            </p-message>
            <p-table 
    [value]="getAssemblies()" 
    [selectionMode]="outputMode ? 'multiple' : 'single'" 
    [selection]="outputMode ? selectedAssemblies : selectedAssemblyService.getSelectedAssembly()" 
    dataKey="AID" 
    styleClass="p-datatable-sm"
    (onRowSelect)="onRowSelect($event)" 
    (onRowUnselect)="onRowUnselect($event)" 
    [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 2rem" *ngIf="outputMode"><p-tableHeaderCheckbox /> </th>
                <!-- <th>Name</th> -->
                <th [attr.colspan]="anyInherited() ? 2 : 1">Description</th>
                <th>Price</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-assembly>
            <tr *ngIf="outputMode">
                <td >
                    <p-tableCheckbox [value]="assembly"/>
                </td>
                <!-- <td>{{assembly.Name}}</td> -->
                <td [innerHTML]="assembly.Description" [attr.colspan]="isInherited(assembly) ? 1 : 2"></td>
                <td *ngIf="isInherited(assembly)"> <p-tag icon="pi pi-warning" [] [value]="determineInherited(assembly)?.CityCode" pTooltip="This assembly is inherited from {{determineInherited(assembly)?.CityCode}}. Changing this assembly will affect all offices that inherit it." tooltipPosition="left" rounded="true" severity="warn"/></td>
                    <td>{{getAllPrice(assembly) | currency : 'USD' }}</td>
                    <td></td>
                </tr>
            <tr [pSelectableRow]="assembly" *ngIf="!outputMode">
                    <!-- <td>{{assembly.Name}}</td> -->
                    <td [innerHTML]="assembly.Description" [attr.colspan]="isInherited(assembly) ? 1 : 2"></td>
                    <td *ngIf="isInherited(assembly)"> 
                      <p-tag icon="pi pi-warning" [value]="determineInherited(assembly)?.CityCode" rounded="true" pTooltip="This assembly is inherited from {{determineInherited(assembly)?.CityCode}}. Changing this assembly will affect all offices that inherit it." tooltipPosition="left" severity="warn"/></td>
                        <td>{{getAllPrice(assembly) | currency : 'USD' }}</td>
                        <td></td>
                    </tr>
            </ng-template>
</p-table>
            
        </div>
      </div>
    </div>
    <p-dialog  header="Edit Assembly" [modal]="true" [draggable]="false" [resizable]="false" [(visible)]="editVisible" [style]="{ width: '90vw', maxWidth: '1400px' }">
        <app-assembly-editor [templateMode]="templateMode" (save)="onSave($event)" (cancel)="onCancelAssembly()"></app-assembly-editor>
    </p-dialog>
    `
})
export class AssemblyTableComponent {
  @Input() templateMode: boolean = false;
  @Output() save = new EventEmitter<Assembly>();
  selectedCategory: Category | null = null;
  selectedAssembly: Assembly | null = null;
  selectedAssemblies: Assembly[] = [];
  categoriesMenu: MenuItem[] = [];
  expandedRows: { [key: number]: boolean } = {};
  clonedAssemblies: { [key: string]: Assembly } = {};
  assemblies: Assembly[] = [];
  editVisible: boolean = false;

  resetValue = false;
  @Input() officeLocked:boolean = false;
  @Input() outputMode: boolean = false;
  @Input() reset = signal<boolean>(false);
  @Input() aidFilters: StandardAssembly[] = [];
  @Output() assembliesChanged = new EventEmitter<Assembly[]>();
  
  @Input() categories: Category[] = [];
  constructor(
    public categoriesService: CategoriesService, 
    public assemblyCacheService: AssemblyCacheService,
    public selectedAssemblyService: AssembliesService,
    public binderDialogService: BinderDialogService,
    public messageService: MessageService,
    public bannerMessagesService: BannerMessagesService,
    public officesService: OfficesService,
  ) {
    effect(() => {
      const reset = this.reset();
      if(reset !== this.resetValue && this.outputMode) {
        this.resetValue = reset;
        this.selectedAssemblies = [];
      }
      const categories = this.categoriesService.categories();
      const assemblies = this.assemblyCacheService.filteredAssemblies();
      if(assemblies) {
this.assemblies = assemblies
      }
      if(categories.length > 0) {
        this.selectedCategory = categories[0];
      }
    });
    effect(() => {
      const assembly = this.selectedAssemblyService.selectedAssembly();
      if(assembly) {
        this.selectedAssembly = assembly;
        this.editVisible = true;
      }
    });
  }

  get categoriesArray(): Category[] {
    return this.categoriesService.categories();
  }

  onEdit(event: any) {
    if (!this.isPositiveInteger(event.target.value)) {
        event.stopPropagation();
    }
}

get messages(): BannerMessage[] {
  return this.bannerMessagesService.messages()?.filter(m => m.type === 'assemblyInherited') || [];
}

set messages(messages: BannerMessage[]) {
  this.bannerMessagesService.replaceMessageType(messages, 'assemblyInherited');
}

onCancelAssembly() {
  this.editVisible = false;
}

anyInherited() {
  return this.getAssemblies().filter(assembly => this.isInherited(assembly)).length > 0;
}

isInherited(assembly: Assembly) {
  const selectedOffice = this.officesService.selectedOffice();
  if(selectedOffice && assembly.FID !== selectedOffice.FID) {
    return true;
  }
  return false;
}

determineInherited(assembly: Assembly) {
    return this.officesService.offices().find(office => office.FID === assembly.FID);
}

getAssemblies() {
  if(this.aidFilters.length > 0) {
    return this.assemblies.filter(assembly => !this.aidFilters.some(filter => filter.AID === assembly.AID));
  }
  return this.assemblies;
}

onRowEditInit(assembly: Assembly) {
  this.clonedAssemblies[assembly.AID.toString() as string] = { ...assembly };
}

onRowSelect(event: any) {
  if(!this.outputMode) {
  this.selectedAssemblyService.setSelectedAssembly(event.data);
  // this.binderDialogService.toggleDialog('Assembly Editor', 'assembly-editor', true);
  this.editVisible = true;
  } else {
    this.selectedAssemblies.push(event.data);
    this.sendOutput();
  }
}

onRowUnselect(event: any) {
  this.selectedAssemblyService.unselectAssembly();
  if(this.outputMode) {
    this.selectedAssemblies = this.selectedAssemblies.filter(assembly => assembly.AID !== event.data.AID);
    this.sendOutput();
  }
}

onRowEditSave(assembly: Assembly) {
  console.log(assembly)
  // if (assembly.Price > 0) {
  //     delete this.clonedAssemblies[assembly.AID.toString() as string];
  //     this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Product is updated' });
  // } else {
  //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Price' });
  // }
}

onRowEditCancel(assembly: Assembly, index: number) {
  this.assemblies[index] = this.clonedAssemblies[assembly.AID.toString() as string];
  delete this.clonedAssemblies[assembly.AID.toString() as string];
}

onSave(event: Assembly) {
  console.log('onSave', event);
  this.assemblyCacheService.updateAssemblies(event);
  this.save.emit(event);
  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assembly saved' });
  this.editVisible = false;
}

getAllPrice(assembly: Assembly) {
    const price = assembly.AssemblyPriceTable.find(price => price.PlanID === 1);
    return price ? price.Price : 0;
}

exceptions(assembly: Assembly) {
    return assembly.AssemblyPriceTable.filter(price => price.PlanID !== 1).length;
}

expandAll() {
  this.expandedRows = this.assemblies.reduce((acc, assembly) => {
    acc[assembly.AID] = true;
    return acc;
  }, {} as { [key: number]: boolean });
}

collapseAll() {
  this.expandedRows = {};
}

toggleRowExpansion(assembly: Assembly) {
  this.expandedRows[assembly.AID] = !this.expandedRows[assembly.AID];
}

isRowExpanded(assembly: Assembly): boolean {
  return !!this.expandedRows[assembly.AID];
}

isPositiveInteger(val: any) {
    let str = String(val);

    str = str.trim();

    if (!str) {
        return false;
    }

    str = str.replace(/^0+/, '') || '0';
    var n = Math.floor(Number(str));

    return n !== Infinity && String(n) === str && n >= 0;
}

sendOutput() {
  if(this.outputMode) {
    console.log('sending output', this.selectedAssemblies);
    this.assembliesChanged.emit(this.selectedAssemblies);
  }
}

}
